const React = require("react");
const RaisedButton = require("material-ui/RaisedButton").default;
const FlatButton = require("material-ui/FlatButton").default;
const Classes = require("./styles.scss");
const NavLink = require("react-router-dom").NavLink;
const Paper = require("material-ui/Paper").default;
const PDFLinkMeasurements = require("static/measurement-guide.pdf");
const PDFLinkTestSwatch = require("static/MyBodyModel-Color-Swatch.pdf");
const QuickStartGuide = require("static/quick-start-guide.pdf");

module.exports = class Instructions extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <div className={Classes.instructionsGroup}>
                <div className={Classes.instructionsHeader}>
                    <h1>Ready to create your body model?</h1>
                    <FlatButton
                        label="Skip to Measurement Form"
                        secondary
                        containerElement={<NavLink to="/body-model/new" />}
                        labelStyle={{
                            textTransform: "inherit"
                        }}
                    />
                </div>

                <Paper
                    style={{ padding: "3rem", margin: "4rem 0" }}
                    className={Classes.instructionsPaper}
                >
                    <h3>Before you begin, here&rsquo;s what you need:</h3>
                    <ul>
                        <li>
                            Wear your typical undergarments and bare feet. If
                            you prefer to be clothed, choose a form-fitting tee
                            and leggings.
                        </li>
                        <li>Flexible measuring tape</li>
                        <li>
                            1 piece of thin elastic, long enough to be tied
                            securely around your waist; if you don&rsquo;t have
                            elastic, try ribbon or yarn
                        </li>
                        <li>
                            2 safety pins if you are wearing leggings; washable
                            marker or eyeliner if your legs are bare (to mark
                            your low hips)
                        </li>
                        <li>
                            Optional: We recommend writing your numbers on paper
                            before entering them online. You can print the full{" "}
                            <NavLink to={PDFLinkMeasurements} target="_blank">
                                Measurement Guide
                            </NavLink>
                            , or just print the{" "}
                            <NavLink to={QuickStartGuide} target="_blank">
                                Quick-Start Guide
                            </NavLink>
                            . If possible, recruit a helper to assist with your
                            measurements
                        </li>
                        <li>
                            Please note: When you create your body model, you
                            can choose your line color. Line darkness can vary
                            by printer.{" "}
                            <NavLink to={PDFLinkTestSwatch} target="_blank">
                                Click here
                            </NavLink>{" "}
                            for a printable test swatch, so you can choose the
                            best line darkness for your printer.
                        </li>
                    </ul>
                </Paper>
                <div className={Classes.instructionsBegin}>
                    <Paper className={Classes.instructionsBeginOne}>
                        <div className={Classes.instructionImg} />
                        <div className={Classes.instructionCopy}>
                            <h2>Step 1</h2>
                            <p>
                                Bend your waist to either side and tie a piece
                                of elastic at your natural crease. Leave it in
                                place because this will help when taking several
                                of the measurements.
                            </p>
                        </div>
                    </Paper>
                    <Paper className={Classes.instructionsBeginTwo}>
                        <div className={Classes.instructionImg} />
                        <div className={Classes.instructionCopy}>
                            <h2>Step 2</h2>
                            <p>
                                To locate your low hip, lift one knee and then
                                the other. The point where you bend is your low
                                hip.{" "}
                                <em>
                                    Note: "Low hip" is different from "full
                                    hip." Your low hip may or may not be the
                                    fullest part of your hips.
                                </em>
                            </p>
                        </div>
                    </Paper>
                    <Paper className={Classes.instructionsBeginThree}>
                        <div className={Classes.instructionImg} />
                        <div className={Classes.instructionCopy}>
                            <h2>Step 3</h2>
                            <p>
                                Using your washable marker or safety pin, mark
                                the low hip point on each side of your body,
                                making sure that the marks are as symmetrical as
                                possible.
                            </p>
                        </div>
                    </Paper>
                </div>
                <RaisedButton
                    label={"Let's Get Started"}
                    primary
                    containerElement={<NavLink to="/body-model/new" />}
                    labelStyle={{
                        textTransform: "inherit"
                    }}
                />
            </div>
        );
    }
};



// WEBPACK FOOTER //
// ./src/routes/instructions/components/Instructions.js